<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container fluid>

    <v-row align="center" justify="start">
        <v-col cols="8" class="pa-0">
            <v-text-field 
            v-model="optionname" dense disabled
            :placeholder="$t('optiondialog_col3')"
            outlined height="43"
            color="#808080"
            hide-details
            />
        </v-col>
        <v-col cols="4" class="pa-0" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
        </v-col>
    </v-row>   

    <v-row>
      <v-dialog style="z-index: 9999;" persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" max-width="940px" >
        <v-card class="dialog_round pa-5">
          <v-row justify="space-between">
            <v-col align="start" cols="12" md="6" sm="6" xs="6">
              <span class="ml-10 dialog_title">{{$t('optiondialog_col3')}}</span>
            </v-col>
            <v-col align="end" cols="12" md="6" sm="6" xs="6">
              <v-btn class="dialog_btn mr-10" rounded large @click="clear_com">{{$t('common_selectcancel')}}</v-btn>
            </v-col>
          </v-row>
          
          <v-card-text>
            <v-container>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-data-table
                    ref="table"
                    :headers="headers_com"
                    :items="itemList_com"
                    v-model="select_com"
                    :no-data-text="$t('common_nodata')"
                    hide-default-footer
                    
                    class="datatablestyle"
                    :items-per-page="pagerow_com"
                    item-key="IDX"
                    >
                    <template v-slot:header.COST_TYPE>
                      <label class="cheader_normal" >{{$t("optiondialog_col1")}}</label>
                    </template>
                    <template v-slot:header.STATE>
                      <label class="cheader_normal" >{{$t("optiondialog_col2")}}</label>
                    </template>
                    <template v-slot:header.NAME>
                      <label class="cheader_normal" >{{$t("optiondialog_col3")}}</label>
                    </template>
                    <template v-slot:header.COST>
                      <label class="cheader_normal" >{{$t("optiondialog_col4")}}</label>
                    </template>
                    <template v-slot:header.REG_START>
                      <label class="cheader_normal" >{{$t("optiondialog_col5")}}</label>
                    </template>
                    <template v-slot:header.REG_END>
                      <label class="cheader_normal" >{{$t("optiondialog_col6")}}</label>
                    </template>

                    <template v-slot:item.NAME="{ item }">
                      <a @click="select_func(item)">{{item.NAME}}</a>
                    </template>
                    <template v-slot:item.STATE="{ item }">  
                      <label> {{ item.STATE == 1 ? $t('optiondialog_msg1') : $t('optiondialog_msg2')}} </label>
                    </template>
                    <template v-slot:item.COST_TYPE="{ item }">  
                      <label> {{ item.COST_TYPE == 1 ? $t('optiondialog_msg3') : $t('optiondialog_msg4') }} </label>
                    </template>
                    <template v-slot:item.COST="{ item }">  
                      <label>{{ priceToString(item.COST) }}</label>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            optionname: String,
            comidx:   Number,
            eventidx: Number,
        },

        data: ()=> ({
            dialog_com : false,
            load_flag : false,
            headers_com: [
              {text: '구분', value: 'COST_TYPE', sortable: false, align:'center' },
              {text: '상태', value: 'STATE', sortable: false, align:'center' },
              {text: '등록 카테고리', value: 'NAME', sortable: false, align:'center'},
              {text: '가격', value: 'COST', sortable: false, align:'center' },
              {text: '접수 시작일시', value: 'REG_START', sortable: false, align:'center' },
              {text: '접수 종료일시', value: 'REG_END', sortable: false, align:'center' },
            ],

            itemList_com: [],
            select_com:[],
            pagerow_com : 999,      //한 페이지에 보여줄 row수
            
        }),

        updated(){
          
          if(this.dialog_com){
            if(!this.load_flag && this.itemList_com.length == 0){
              this.load_flag = false;
              this.loadpage_com();
            }
          }else{
            this.load_flag = false;
          }

        },
        

        methods: {

            priceToString(price) {
              return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },

            search_run_com(){
                this.loadpage_com();
            },

            loadpage_com(){
                
                this.$http.post(this.$host+'/api/EventOptionList',{
                      ADMIN_IDX: this.$session.get("ADMIN_IDX")
                    , COMIDX: this.comidx
                    , EVENT_IDX: this.eventidx
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                    this.load_flag = true;
                    if(result.data.resultCode == 0){

                        //토큰 저장
                        if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                          this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                        }
                        if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                          this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                        }

                        this.totalcnt_com = result.data.totalcnt;
                        const list = result.data.resultData;
                        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                        list.forEach(element => {
                            this.itemList_com.push(element); 
                        });

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    
                });

            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },

            //선택 초기화
            clear_com () {
                this.$emit('callback', {NAME:'', IDX:''})
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },
            
            //선택
            select_func(select_item){
              this.$emit('callback', select_item)
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
              this.select_com = [];
              this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },

            showpopup_com(){
                if(this.comidx == null){
                  this.$alert(this.$t('optiondialog_msg5'));
                  return;
                }
                if(this.eventidx == null){
                  this.$alert(this.$t('optiondialog_msg6'));
                  return;
                }
                this.load_flag = false;
                this.dialog_com = true;
                
            },


        }

    }
</script>

<style scoped>

</style>